import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Home, Search } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFound = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white px-6" data-testid="not-found-page">
      <div className="text-center max-w-sm">
        <div className="text-8xl font-bold text-gray-200 mb-4 font-rubik">404</div>
        <h1 className="text-2xl font-bold text-gray-600 mb-2 font-rubik">
          Página no encontrada
        </h1>
        <p className="text-gray-400 mb-8">
          La página que buscas no existe o fue movida.
        </p>

        <div className="flex flex-col gap-3">
          <Link to="/prelanzamiento">
            <Button className="w-full bg-primary hover:bg-primary-hover rounded-xl py-6 font-semibold" data-testid="go-home-btn">
              <Home className="w-4 h-4 mr-2" />
              Ir al inicio
            </Button>
          </Link>
          <Link to="/prelanzamiento">
            <Button variant="outline" className="w-full rounded-xl py-6 border-gray-200" data-testid="explore-btn">
              <Search className="w-4 h-4 mr-2" />
              Explorar actividades
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
